import { useBreakpoint } from '@vivino/js-react-common-ui';
import { truncate } from '@vivino/js-web-common';
import React from 'react';
import { region, style as wineStyle } from 'vivino-js/apiPropTypes';

import WineTasteStyleDesktop from './components/WineTasteStyle.desktop.presentational';
import WineTasteStyleMobile from './components/WineTasteStyle.mobile.presentational';

import placeholderImage from './images/placeholder.png';

function WineTasteStyle({ styleData, regionData }) {
  const { isMobile } = useBreakpoint();

  const img = isMobile
    ? regionData?.background_image?.variations?.medium || regionData?.background_image?.location
    : regionData?.background_image?.location || placeholderImage;

  if (!styleData?.description) {
    return null;
  }
  const descriptionAsTags = truncate({
    text: styleData.description,
    length: 400,
  })
    .split(/(\r\n|\n|\r)/gm)
    .map((text, idx) => <p key={idx}>{text}</p>);

  if (isMobile) {
    return (
      <WineTasteStyleMobile
        img={img && img}
        styleData={styleData}
        descriptionAsTags={descriptionAsTags}
      />
    );
  }

  return (
    <WineTasteStyleDesktop
      img={img && img}
      styleData={styleData}
      descriptionAsTags={descriptionAsTags}
    />
  );
}

WineTasteStyle.propTypes = {
  styleData: wineStyle,
  regionData: region,
};

export default WineTasteStyle;
